import {
  Component,
  ElementRef,
  Input,
  SimpleChanges,
  OnChanges,
  OnDestroy,
  DoCheck,
} from '@angular/core';
import {
  DynamicHTMLRef,
  DynamicHTMLRendererService,
} from '../../../services/dynamic-html-renderer.service';

@Component({
    selector: 'mec-dynamic-html',
    template: '',
    styleUrls: ['./dynamic-html.component.scss'],
    standalone: false
})
export class DynamicHtmlComponent implements DoCheck, OnChanges, OnDestroy {
  @Input() content: string;

  private ref: DynamicHTMLRef = null;

  constructor(
    private renderer: DynamicHTMLRendererService,
    private elementRef: ElementRef
  ) {}

  ngOnChanges(_: SimpleChanges) {
    if (this.ref) {
      this.ref.destroy();
      this.ref = null;
    }
    if (this.content && this.elementRef) {
      this.ref = this.renderer.renderInnerHTML(this.elementRef, this.content);
    }
  }

  ngDoCheck() {
    if (this.ref) {
      this.ref.check();
    }
  }

  ngOnDestroy() {
    if (this.ref) {
      this.ref.destroy();
      this.ref = null;
    }
  }
}
